export const getTodayTo25YearsTimestamp = () => {
  // Get the current timestamp in seconds
  const currentTimestamp = Math.round(Date.now() / 1000);

  // Calculate the number of seconds in 25 years
  const secondsIn25Years = 25 * 365 * 24 * 3600;
  return currentTimestamp + secondsIn25Years;
};
